import { render, staticRenderFns } from "./CaseWithClaimSelect.vue?vue&type=template&id=43d62172"
import script from "./CaseWithClaimSelect.vue?vue&type=script&lang=js"
export * from "./CaseWithClaimSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports